import { CamelCaseKeys } from "@utils/typescript";
import { InsuranceTypesEnum } from "./InsuranceType";
import { User } from "./User";

export enum UserRoles {
  Customer = 'customer',
  Frontline = 'frontline',
  Insurer = 'insurer',
  Company = 'company',
  Hospital = 'hospital',
  Processing = 'processing',
}

export enum UserStatuses {
  Pending = 'pending',
  Confirmed = 'confirmed',
}

export type UserProfile = User & CamelCaseKeys<{
  role: UserRoles;
  insurance_types: InsuranceTypesEnum[];
  status: UserStatuses;
}>;
